<style lang="scss" scoped>
ul {
  list-style: none;
}

a {
  text-decoration: none;
}

.header {
  background: #fff;
  height: 120px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'syht';
  .logo-wrap {
    display: flex;
    align-items: center;
    padding: 40px;
    .logo {
      height: 60px;
    }
  }

  .search {
    width: 300px;
    height: 42px;
    margin-left: 40px;
    background-image: linear-gradient(#f2f2f2 10%, #fff 70%);
    border: 2px solid #e9ebee;
    border-radius: 5px;
    overflow: hidden;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      width: 20px;
      height: 20px;
      transform: translateY(-50%);
      left: 1em;
      display: block;
      opacity: 0.3;
      background: url('../../assets/newHome/icon-search.png') no-repeat;
      background-size: 20px;
    }

    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      font-size: 18px;
      background: #fff;
      padding-left: 2.5em;

      &::placeholder {
        color: #d1d1d1;
      }
    }
  }

  .nav {
    font-size: 18px;
    display: flex;
    margin-left: 60px;

    ul {
      display: flex;
      list-style: none;
      line-height: 55px;

      li{
        list-style: none;
      }
      a {
        color: #000;
        margin: 0 15px;
        white-space: nowrap;
        font-family: syht;
        &.active,
        &:hover {
          color: #828282;
        }
      }
    }
  }

  .login {
    font-size: 18px;
    white-space: nowrap;
    span {
      color: #f3f4f6;
    }
    a {
      color: #000;
      margin: 0 10px;
      cursor: pointer;
    }
    .register {
      width: 90px;
      height: 42px;
      background-image: linear-gradient(#fff, #eee);
      border: 2px solid #e9ebee;
      border-radius: 10px;
      color: #000;
      font-size: 18px;
      cursor: pointer;
      margin-right: 40px;
    }
  }
}

</style>
<template>
  <header class="header">
    <div class="logo-wrap">
      <img src="../../assets/newHome/logo.png" class="logo" alt="" />
      <div class="search">
        <input placeholder="搜索模型，数据集，用户..." />
      </div>
      <nav class="nav">
        <ul>
          <li v-for="item in routes" :key="item.name" @click="handleHrefClick(item)">
            <router-link :to="item.path" :class="{'active': item.name === activeName}">{{ item.name }}</router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="login">
      <a  @click="handleGoPage('login')">登录</a>
      <button class="register" @click="handleGoPage('signup')">注册</button>
    </div>
  </header>
</template>
<script>
export default {
  name: 'headerAgain',
  data () {
    return {
      routes: [
        {
          name: '首页',
          path: '/home',
          url: ''
        },
        {
          name: 'BBT模型',
          path: 'http',
          url: 'https://bbt.ssymmetry.com/index.html'
        },
        {
          name: '数据',
          path: 'http',
          url: 'https://bbt.ssymmetry.com/index.html'
        },
        {
          name: '文档',
          path: 'http',
          url: 'https://bbt.ssymmetry.com/index.html'
        },
        {
          name: '研究',
          path: '/model',
          url: ''
        },
        {
          name: '解决方案',
          path: '/data',
          url: ''
        },
        {
          name: '价格',
          path: '/evaluation',
          url: ''
        },
        {
          name: '社区',
          path: 'http',
          url: 'https://bbs.ssymmetry.com/#/'
        }
      ],
      activeName: '研究'
    }
  },
  components: {
  },
  methods: {
    handleHrefClick(item) {
      this.activeName = item.name
      if(/^http/.test(item.url)){
          window.open(item.url)
      }else{
      window.open(window.location.origin + '/' + item.url)}
    },
    handleGoPage(page) {
      this.$router.push({ path: `/${page}` })
    }
  },
  mounted() {
    
  },
}
</script>



// WEBPACK FOOTER //
// src/components/header/newHeaderAgain.vue